import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";

export default {
  name: "ParceiroAtendimentoCategoria",
  components: {
    TableList
  },
  data() {
    return {
      headers: [
        {label:'Código', field:'Codigo'},
        {label:'Nome', field:'Nome', classHeader:'text-left', classField:'text-left'}
      ],
      permissionIsAuthorize: 'ParceiroAtendimentoCategoria',
      modalTitle: "Nova Categoria do Atendimento ao Parceiro",
      countFilter: 0,
      itemList: [],
      filter: {
        Id: null,
        Codigo: null,
        Nome: null,
        EhExcluido: false
      },
      idField: 0,
      formField: {
        Codigo: null,
        Nome: null
      },
      isSeeing: false,
      loading: false,
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFieldForm: false
    };
  },
  mounted() {
    this.ListarParceiroAtendimentoCategoria();
  },
  methods: {
    OpenField(item, index, eventName) {
      this.validatedFieldForm = false;
      this.ResetFormField();

      if (eventName == 'Update') {
        // Edit
        this.pOpened = index;
        this.idField = item.Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Campo";
        this.BuscarParceiroAtendimentoCategoria();
      } else if (eventName == 'Add') {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Categoria do Atendimento ao Parceiro";
        this.ResetFormField();
      } else {
        // View
        this.pOpened = index;
        this.idField = item.Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.BuscarParceiroAtendimentoCategoria();
      }
      this.$bvModal.show("mFormField");
    },
    
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListarParceiroAtendimentoCategoria();
    },

    ResetFilter() {
      this.filter = {
        Id: null,
        Codigo: null,
        Nome: null,
        EhExcluido: false
      };
      this.ListarParceiroAtendimentoCategoria();
    },

    ResetFormField() {
      this.formField = {
        Codigo: null,
        Nome: null
      };
    },

    SaveField() {
      this.validatedFieldForm = true;
      this.$refs.FieldValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loading = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.AdicionarParceiroAtendimentoCategoria();
          } else {
            // Update
            this.AlterarParceiroAtendimentoCategoria();
          }
        }
      });
    },

    AdicionarParceiroAtendimentoCategoria() {
      this.$store
        .dispatch("AdicionarParceiroAtendimentoCategoria", this.formField)
        .then(() => {
          this.$makeToast("O campo foi cadastrado com sucesso.","success","Campo cadastrado");
          this.ListarParceiroAtendimentoCategoria();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao criar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    AlterarParceiroAtendimentoCategoria() {
      this.$store.dispatch("AlterarParceiroAtendimentoCategoria", this.formField)
        .then(() => {
          this.$makeToast("O Campo foi atualizado com sucesso.","success","Campo atualizado");
          this.ListarParceiroAtendimentoCategoria();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Erro ao atualizar campo, tente novamente.","danger","Erro ao atualizar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    BuscarParceiroAtendimentoCategoria() {
      if (this.idField != 0) {
        this.loading = true;
        this.$store.dispatch("BuscarParceiroAtendimentoCategoria", { id: this.idField })
          .then(response => {
            this.formField = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo","danger","Erro ao carregar o campo",error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    ListarParceiroAtendimentoCategoria() {
      this.loading = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Nome)) this.countFilter++;
      if (hasValue(this.filter.EhExcluido)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.Id": this.filter.Id,
        "Object.Codigo": this.filter.Codigo,
        "Object.Nome": this.filter.Nome,
        "Object.EhExcluido": this.filter.EhExcluido
      };
      delete data.TotalItems;
      this.$store.dispatch("ListarParceiroAtendimentoCategoria", data)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
                          "danger","Erro ao listar os Campos",error);
        })
        .finally(() => (this.loading = false));
    },

    ExcluirParceiroAtendimentoCategoria(id) {
      this.$store.dispatch("ExcluirParceiroAtendimentoCategoria", { id: id })
        .then(() => {
          this.$makeToast("O Campo foi removido com sucesso.","success","Campo removido");
          this.ListarParceiroAtendimentoCategoria();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao remover Campo",error);
        });
    },

    ConfirmarExclusaoParceiroAtendimentoCategoria(item, index, eventName) {
      this.$makeMsgBox("Você tem certeza que deseja remover " + item.Nome + " ?",
                       "Confirmar",this.ExcluirParceiroAtendimentoCategoria, item.Id);
    },

    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/ParceiroAtendimentoCategoria/ParceiroAtendimentoCategoria.js